import styled from 'styled-components';

const FormContainer = styled.div`
    box-sizing: border-box;
    width: 100%;
    pointer-events: ${({loading=false}) => loading ? 'none'  : 'initial'};
    opacity:  ${({loading=false}) => loading ? '0.5'  : '1'};
`;

export default FormContainer;